import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-bootstrap/Modal'
import { Button } from 'primereact/button'
import ButtonRB from 'react-bootstrap/Button'
import styles from '../../css/modals/ModalLeasingGroup.module.css'
import { postData, putData } from '../../actions/servicesHttp'
import { popupSimple } from '../generals/popups'
import $ from 'jquery'
import { formatDateDenunciations } from '../generals/charts/utils/DatesFormats'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function ModalLeasingGroup ({ lease, show, onHide, title, btnError, btnSuccess, groupId, reload }) {
  const tomorrow = new Date()
  const { t } = useTranslation('dashboardGroup')
  const navigate = useNavigate()

  const [data, setData] = useState()
  const [mode, setMode] = useState('empty')

  const start = new Date(data?.startDate)
  const startDateOnly = new Date(start.getUTCFullYear(), start.getUTCMonth(), start.getUTCDate())
  const end = new Date(data?.endDate)
  const endDateOnly = new Date(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate())
  const today = new Date()
  const todayDateOnly = new Date(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate())

  const handleChange = (e, info) => {
    setData({
      ...info,
      [e.target.id]: e.target.value
    })
  }

  const addLease = async (url, groupId) => {
    $('#btnLeasingGroupModalSucess').prop('disabled', true)
    const body = {
      groupId,
      ...data
    }

    const res = await postData(url, body, navigate)

    if (res?.status === 201) {
      popupSimple('success', t('modalLeasingGroup.message1'))
      reload()
    } else if (res?.status === 200) {
      popupSimple('error', t('modalLeasingGroup.message2'))
    } else {
      popupSimple('error', t('modalLeasingGroup.message3'))
    }

    setData()
    setTimeout(() => {
      $('#btnLeasingGroupModalSucess').prop('disabled', false)
    }, 1500)
    onHide()
  }

  const updateLease = async (url, groupId, data) => {
    $('#btnLeasingGroupModalSucess').prop('disabled', true)

    const body = {
      groupId,
      ...data
    }

    const res = await putData(url, body, navigate)

    if (res?.status === 201) {
      popupSimple('success', t('modalLeasingGroup.message1'))
      reload()
    } else {
      popupSimple('error', t('modalLeasingGroup.message3'))
    }

    setData()
    setTimeout(() => {
      $('#btnLeasingGroupModalSucess').prop('disabled', false)
    }, 1500)
    onHide()
  }

  useEffect(() => {
    if (lease) {
      setMode('read')
      setData(lease)
    }
  }, [lease, show])

  return (
            <>
                <Modal
                    show={show}
                    onHide={() => {
                      onHide()
                      setData()
                    }}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    key={'installApplications'}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="example-custom-modal-styling-title">
                            {title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {!lease?.id && <div>
                            <div
                                id={'divOrganization'}
                                key={'divKeyOrganization'}
                                className={styles.div_input}
                            >
                                <label>{t('modalLeasingGroup.label1')}</label>
                                <input
                                    key={'keyOrganization'}
                                    id={'organization'}
                                    name={'organization'}
                                    onChange={(e) => handleChange(e, data)}
                                    type={'text'}
                                    className={styles.input_denunciation}
                                    value={data?.organization}
                                />
                            </div>
                            <div
                                key={'divKeyStartDate'}
                                id={'divStartDate'}
                                className={styles.div_input_date}
                            >
                                <label>{t('modalLeasingGroup.label2')}</label>
                                <input
                                    key={'keyStartDate'}
                                    id={'startDate'}
                                    name={'startDate'}
                                    value={data?.startDate}
                                    onChange={(e) => handleChange(e, data)}
                                    type={'date'}
                                    className={styles.input_denunciation_date}
                                    min={tomorrow.toISOString().split('T')[0]}
                                    lang="en"
                                />
                            </div>
                            <div
                                key={'divKeyEndDate'}
                                id={'divEndDate'}
                                className={styles.div_input_date}
                            >
                                <label>{t('modalLeasingGroup.label3')}</label>
                                <input
                                    key={'keyEndDate'}
                                    id={'endDate'}
                                    name={'endDate'}
                                    value={data?.endDate}
                                    onChange={(e) => handleChange(e, data)}
                                    type={'date'}
                                    className={styles.input_denunciation_date}
                                    min={tomorrow.toISOString().split('T')[0]}
                                />
                            </div>
                        </div>}
                        {lease?.id && mode === 'read' && <div className={styles.divRead}>
                          {(endDateOnly > todayDateOnly) && <Button className={styles.buttonLG} icon='pi pi-pencil' rounded outlined severity="secondary" tooltip="Editar arrendamiento" tooltipOptions={{ position: 'bottom' }} onClick={() => setMode('edit')} />}
                          <p><span className={styles.span_date}>{t('modalLeasingGroup.label1')}</span> {lease?.organization}</p>
                          <p><span className={styles.span_date}>{t('modalLeasingGroup.label2')}</span> {formatDateDenunciations(lease?.startDate)}</p>
                          <p><span className={styles.span_date}>{t('modalLeasingGroup.label3')}</span> {formatDateDenunciations(lease?.endDate)}</p>
                        </div>}
                        {lease?.id && mode === 'edit' && (endDateOnly > todayDateOnly) && <div className={styles.divRead}>
                          <div
                            id={'divOrganization'}
                            key={'divKeyOrganization'}
                            className={styles.div_input}
                          >
                            <label>{t('modalLeasingGroup.label1')}</label>
                            <input
                              key={'keyOrganization'}
                              id={'organization'}
                              name={'organization'}
                              onChange={(e) => handleChange(e, data)}
                              type={'text'}
                              className={styles.input_denunciation}
                              value={data?.organization}
                            />
                          </div>
                          {startDateOnly > todayDateOnly
                            ? (
                            <div
                                key={'divKeyStartDate'}
                                id={'divStartDate'}
                                className={styles.div_input_date}
                            >
                                <label>{t('modalLeasingGroup.label2')}</label>
                                <input
                                    key={'keyStartDate'}
                                    id={'startDate'}
                                    name={'startDate'}
                                    value={data?.startDate}
                                    onChange={(e) => handleChange(e, data)}
                                    type={'date'}
                                    className={styles.input_denunciation_date}
                                    min={tomorrow.toISOString().split('T')[0]}
                                />
                            </div>
                              )
                            : (<p><span className={styles.span_date}>Fecha de Inicio:</span> {formatDateDenunciations(lease?.startDate)}</p>)
                          }
                          <div
                            key={'divKeyEndDate'}
                            id={'divEndDate'}
                            className={styles.div_input_date}
                          >
                            <label>{t('modalLeasingGroup.label3')}</label>
                            <input
                              key={'keyEndDate'}
                              id={'endDate'}
                              name={'endDate'}
                              value={data?.endDate}
                              onChange={(e) => handleChange(e, data)}
                              type={'date'}
                              className={styles.input_denunciation_date}
                              min={tomorrow.toISOString().split('T')[0]}
                            />
                          </div>
                        </div>}
                    </Modal.Body>
                    <Modal.Footer>
                        <ButtonRB onClick={() => {
                          onHide()
                          setData()
                          setMode('empty')
                        }} variant="danger">
                            {btnError}
                        </ButtonRB>
                        <ButtonRB onClick={!lease?.id ? () => addLease('lease', groupId) : () => updateLease('lease', groupId, data)} variant="primary" id="btnLeasingGroupModalSucess" >
                            {btnSuccess}
                        </ButtonRB>
                    </Modal.Footer>
                </Modal>
            </>
  )
}

ModalLeasingGroup.propTypes = {
  onHide: PropTypes.func,
  lease: PropTypes.object,
  title: PropTypes.string,
  show: PropTypes.bool,
  btnError: PropTypes.string,
  btnSuccess: PropTypes.string,
  groupId: PropTypes.number,
  reload: PropTypes.func
}
